import { createContext } from 'react';

import type { INotificationContext } from './types';

export default createContext<INotificationContext>({
  notification: () => {},
  close: () => {},
});
